import { render, staticRenderFns } from "./introduction.vue?vue&type=template&id=b4d53d2a&scoped=true"
import script from "./introduction.vue?vue&type=script&setup=true&lang=js"
export * from "./introduction.vue?vue&type=script&setup=true&lang=js"
import style0 from "./introduction.vue?vue&type=style&index=0&id=b4d53d2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4d53d2a",
  null
  
)

export default component.exports